/* eslint-disable @nx/enforce-module-boundaries */
import {
  AfterViewInit,
  Component,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { DetailTabItemComponent } from 'admin-drivers/src/app/common/components/detail-tab-item/detail-tab-item.component';
import { DriverService } from 'admin-drivers/src/app/api/services/driver.service';
import { map } from 'rxjs';
import { PreloadImgComponent } from '@t-llevo/common-ui';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 't-llevo-driver-vehicle-detail-tab',
  standalone: true,
  imports: [
    NgTemplateOutlet,
    PreloadImgComponent,
  ],
  template: `
    <div class="row w-100 py-2">
      <table class="details-table col-12 col-lg-7 mb-2">
        <tr>
          <td>Tipo de vehículo:</td>
          <td>{{ data()?.vehicleType?.name }}</td>
        </tr>
        <tr>
          <td>Color:</td>
          <td>{{ data()?.color }}</td>
        </tr>
        <tr>
          <td>Marca:</td>
          <td>{{ data()?.mark }}</td>
        </tr>
        <tr>
          <td>Modelo:</td>
          <td>{{ data()?.model }}</td>
        </tr>
        <tr>
          <td>Número de matrícula:</td>
          <td>{{ data()?.plate }}</td>
        </tr>
      </table>
      <ng-container #outlet [ngTemplateOutlet]="content"> </ng-container>
    </div>

    <ng-template #content>
      <commonui-preload-img
        #img
        class="col-10 col-lg-5"
        [urlImg]="photo!"
        [containerClass]="'shadow-sm'"
        imgClass="w-100 h-100"
        [containerHeight]="100"
        [containerWidth]="100"
        unit="%"
        [style.height]="img.onErrorCount > 1 ? '200px !important' : ''"
      ></commonui-preload-img>
    </ng-template>
  `,
})
export class DriverVehicleDetailTabComponent implements AfterViewInit {
  private srv = inject(DriverService);
  protected photo: string | null = null;
  data = toSignal(
    this.srv.item$.pipe(
      map((data) => {
        if (data) {
          this.photo = data.vehicle.vehicleType.photo;
          return data.vehicle;
        }
        return null;
      })
    )
  );

  @ViewChild('outlet', { read: ViewContainerRef }) outletRef!: ViewContainerRef;
  @ViewChild('content', { read: TemplateRef })
  contentRef!: TemplateRef<unknown>;

  ngAfterViewInit(): void {
    this.srv.item$.subscribe(() => this.rerender());
  }

  private rerender() {
    this.outletRef.clear();
    this.outletRef.createEmbeddedView(this.contentRef);
  }
}
